import React from "react";
import { motion } from "framer-motion";
import { WaxSeal } from "./WaxSeal";

export const PaidBanner = ({ theme, themeName, brand }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    data-testid="invoice-paid-banner"
    className={`mt-10 relative border p-6 ${theme.bannerPaid}`}
    style={theme.bgAccent ? { borderColor: brand } : undefined}
  >
    <div className="text-sm uppercase tracking-[0.22em]" style={{ color: brand }}>
      Paid
    </div>
    <div className={`${theme.muted} text-sm mt-2 max-w-[70%]`}>
      This invoice has been confirmed by the creator.
    </div>
    <div className="absolute -top-6 -right-4 pointer-events-none">
      <WaxSeal theme={themeName} brand={brand} />
    </div>
  </motion.div>
);

export const PendingBanner = ({ theme }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    data-testid="invoice-pending-banner"
    className={`mt-10 border p-6 ${theme.bannerPending}`}
  >
    <div className="text-sm uppercase tracking-[0.22em]">Awaiting confirmation</div>
    <div className={`${theme.muted} text-sm mt-2`}>
      Thanks — we're watching the blockchain. This invoice will auto-mark paid once your transaction confirms.
    </div>
  </motion.div>
);
